import React, { Fragment } from 'react';
import { Reveal } from '../Reveal';
import { SectionEyebrow } from '../SectionEyebrow';
import { QuoteIcon } from 'lucide-react';
const quotes = ['"El equilibrio interior no se trata de alcanzar perfección, sino de crear una relación más honesta y armoniosa con todas las partes de tu ser."', '"Tu cuerpo no es solo un vehículo físico. Es el templo desde donde experimentas la vida, sostienes tu energía y construyes tu bienestar."', '"Tus emociones no son enemigas. Son mensajeros internos que revelan necesidades, límites, heridas y oportunidades de crecimiento."', '"La plenitud no nace de mejorar una sola área de la vida, sino de integrar todas las dimensiones que forman parte de quien eres."'];
export const Preview: React.FC = () => <section className="relative bg-navy-deep py-28 lg:py-44 overflow-hidden" data-id="element-303">
    <div className="absolute inset-0" style={{
    background: 'radial-gradient(ellipse at center, rgba(212,175,122,0.1), transparent 60%)'
  }} data-id="element-304" />

    <div className="relative max-w-6xl mx-auto px-6 lg:px-8" data-id="element-305">
      <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-306">
        <Reveal data-id="element-307">
          <SectionEyebrow data-id="element-308">Fragmentos</SectionEyebrow>
        </Reveal>
        <Reveal delay={0.1} data-id="element-309">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-ivory mb-5 leading-[1.1]" style={{
          fontWeight: 300
        }} data-id="element-310">
            Una{' '}
            <span className="italic gold-text" style={{
            fontWeight: 400
          }} data-id="element-311">
              mirada al interior
            </span>
          </h2>
        </Reveal>
        <Reveal delay={0.15} data-id="element-312">
          <p className="text-ivory/60 text-lg font-light leading-[1.8]" data-id="element-313">
            Pequeños fragmentos del viaje que encontrarás dentro del libro.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 gap-7 lg:gap-10" data-id="element-314">
        {quotes.map((q, i) => <Reveal key={i} delay={i * 0.08} data-id="element-315">
            <div className="paper-card rounded-lg p-8 lg:p-10 relative h-full" style={{
          boxShadow: '0 30px 60px -20px rgba(0,0,0,0.5), 0 1px 0 rgba(255,255,255,0.6) inset',
          transform: i % 2 === 0 ? 'rotate(-0.4deg)' : 'rotate(0.4deg)'
        }} data-id="element-316">
              <div className="absolute top-5 right-5" data-id="element-317">
                <span className="text-[10px] uppercase tracking-[0.3em] text-gold-deep/70 border border-gold-deep/30 rounded-full px-3 py-1" data-id="element-318">
                  Preview
                </span>
              </div>
              <QuoteIcon className="w-7 h-7 text-gold-deep mb-5" strokeWidth={1.2} data-id="element-319" />
              <p className="font-serif text-xl lg:text-2xl leading-[1.5] text-navy-deep italic" data-id="element-320">
                {q}
              </p>
              <div className="mt-8 pt-5 border-t border-gold-deep/20 flex items-center justify-between" data-id="element-321">
                <span className="text-xs uppercase tracking-[0.25em] text-gold-deep/70 font-medium" data-id="element-322">
                  Capítulo {i + 1}
                </span>
                <span className="font-serif italic text-sm text-navy-deep/60" data-id="element-323">
                  D.N.
                </span>
              </div>
            </div>
          </Reveal>)}
      </div>
    </div>
  </section>;